'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var MINUTES = exports.MINUTES = 'MINUTES';
var HOURS = exports.HOURS = 'HOURS';
var DAYS = exports.DAYS = 'DAYS';